import { Box } from '@mui/material';
import React from 'react';
import { KitPill } from '../common/MobileKit';
import { protoIcon } from '../common/ProtoIcon';
import { ListBlock, MiniStat, PagedList } from './MobileReportLists';

/**
 * Lista de ordens do Relatório de Ordens de Serviço no shell mobile (equivalente mobile da
 * tabela/cartão do desktop). Só apresentação: dados e formatação vêm de `ServiceOrderReport.js`.
 */

const ChevronRight = protoIcon('right');

const statusTone = (status) => {
    const key = (status || '').toLowerCase();
    if (key === 'finalizada' || key === 'paga' || key === 'faturada') return 'success';
    if (key === 'cancelada' || key === 'estornada') return 'danger';
    if (key === 'em execucao' || key === 'em execução') return 'info';
    return 'warning';
};

/**
 * - rows: ordens já ordenadas
 * - getRow(row) -> { date, status, total, totalWithDiscount, productsCost, externalCost, totalCost, payments }
 *   (valores monetários já formatados, com "R$")
 * - onOpen(row)? abre a visualização (omita sem permissão)
 */
export function OrderList({ rows, getRow, onOpen, pageSize = 20 }) {
    return (
        <PagedList
            rows={rows}
            pageSize={pageSize}
            noun="ordens"
            empty="Nenhuma ordem no período"
            renderRow={(row) => {
                const r = getRow(row);
                return (
                    <ListBlock onClick={onOpen ? () => onOpen(row) : undefined}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Box sx={{ flex: 1, minWidth: 0, fontWeight: 700, fontSize: 14, lineHeight: 1.4 }}>{r.date || '—'}</Box>
                            <KitPill tone={statusTone(r.status)}>{r.statusLabel || r.status || '—'}</KitPill>
                            {onOpen && <Box sx={{ color: 'text.disabled', display: 'inline-flex', flexShrink: 0 }}><ChevronRight size={18} /></Box>}
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: '10px', mt: '8px' }}>
                            <MiniStat label="Total c/ desconto" value={r.totalWithDiscount} strong />
                            <MiniStat label="Total" value={r.total} muted={r.totalZero} />
                        </Box>
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '10px', mt: '8px' }}>
                            <MiniStat label="Peças" value={r.productsCost} muted={r.productsCostZero} />
                            <MiniStat label="Terceirizado" value={r.externalCost} muted={r.externalCostZero} />
                            <MiniStat label="Custo total" value={r.totalCost} muted={r.totalCostZero} />
                        </Box>
                        {r.payments && (
                            <Box sx={{ fontSize: 12, color: 'text.disabled', mt: '8px', lineHeight: 1.4 }}>{r.payments}</Box>
                        )}
                    </ListBlock>
                );
            }}
        />
    );
}
